/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'breakpoints'
],
function(
    $,
    Mustache,
    pip,
    breakpoints
){

	var innerTemplate = '\
    <div class="tooltip_header">\
      {{#templates.aisleAndBayHeader}}\
        {{{templates.aisleAndBayHeader}}}\
      {{/templates.aisleAndBayHeader}}\
      {{^templates.aisleAndBayHeader}}\
        <a href="" class="tooltip_close">Close</a>\
        <h2 class="tooltip_title">{{title}}</h2>\
      {{#templates.header}}{{{templates.header}}}{{/templates.header}}\
      {{/templates.aisleAndBayHeader}}\
    </div>\
    <div class="tooltip_inner">\
      {{{templates.body}}}\
    </div>\
    {{#templates.footer}}\
      <div class="tooltip_footer">\
      {{{templates.footer}}}\
      </div>\
    {{/templates.footer}}';

	var _template = '\
		<div id="{{templates.id}}" data-guid="{{guid}}" class="tooltip">\
			<div class="tooltip_inner_wrapper">'
		+ innerTemplate
		+ '</div>\
		</div>';

	var incr = 0;

	var Tooltip = function Tooltip(params) {
        this.guid = incr++;
        this.params = params;
        this.templates = {
        	body: null,
        	footer: null
        };
        this.title = null;
        this.classname = null;

        var self = this;
        var closeTooltip = function closeTooltip(selector) {
        	if (!$(selector).closest('[data-guid]').length) {
                 $(selector).off('.tt');
                 return;
           }
           $(selector).fadeOut(200, function() {
               if (breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small')) {
                   $('body').removeClass('noscroll');
               }
               $(this).remove();
           });
        };

        $(document).on('click.tt', '.tooltip_close, .aisle-and-bay-tooltip__close svg', function(e) {
               e.preventDefault();
               closeTooltip($(this).closest('.tooltip'));
        });

        $(document).on('click.tt', function(e) {
               if($('.tooltip').length) closeTooltip('.tooltip');
        });

        $(document).on('click.tt', '.tooltip', function(e) {
               e.stopPropagation();
        });

        if (params.init) {
               params.init.call(self);
        };

        if(pip.platform === 'TABLET'){
        	$(window).on("orientationchange", function(){
    			var position = $(params.callToActionSelector).offset();
        		if ($('[data-guid="' + self.guid + '"]').is(':visible')){
        			$('[data-guid="' + self.guid + '"]').css({
        				top: position.top + 30,
        				left: position.left - 100
        			});
        		}
        	});
        }
	};

	Tooltip.prototype.build = function build(callback) {
		if ($('[data-guid="' + this.guid + '"]').is(':visible')) return;


		// GLOBAL -- mustache
		var _html = $(Mustache.to_html(_template, {
			templates: this.templates,
			title: this.title,
			classname: this.classname,
			guid: this.guid
		}));

		var _offset = $(this.params.callToActionSelector).offset();
		var cta_width = $(this.params.callToActionSelector).width();

		_html.css({
			top: _offset.top + 30,
			left: (_offset.left + (cta_width / 2)) - 160
		});

		if (this.classname) _html.addClass(this.classname);
		if (!this.templates.footer) _html.addClass('no-footer');

		$('body').prepend(_html);
		if (callback) callback(_html.html());

	};

	Tooltip.prototype.display = function display() {
        if (breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small')) {
            $('body').addClass('noscroll');
        }
        var el = $('[data-guid="' + this.guid + '"]');
		el.fadeIn(200);
        repositionIfOffscreen(el);
	};

	Tooltip.prototype.rebuild = function rebuild() {
		if ($('[data-guid="' + this.guid + '"]').is(':visible')) {

			// GLOBAL -- mustache
			var _html = $(Mustache.to_html(innerTemplate, {
				templates : this.templates,
				title : this.title,
				classname : this.classname,
				guid : this.guid
			}));
			$('[data-guid="' + this.guid + '"]' + ' > .tooltip_inner_wrapper').html(_html);
		} else {
			this.build();
		}
	};

	function repositionIfOffscreen($el) {
        var rect = $el[0].getBoundingClientRect();
        if(rect.left <= 0) {
            $el.css('left', 10);
        }
        if((rect.right + 25) >= (window.innerWidth || document.documentElement.clientWidth)) {
            $el.css({
                'left': 'auto',
                'right': 15
            });
        }
    }


	return {
		create: function(params){
			return new Tooltip(params);
		}
	}


});

}.call(window));